import './index.css'
import cn from 'clsx'
import { isSameDay } from 'date-fns'

import React, { Component } from 'react'
import DateRangePicker from 'components/common/date-range-picker'
import FilterRow from '../filter-row'
const minDate = new Date(0)
type Props = {
  dateStart: Date
  dateEnd: Date | null | undefined
  disabled: boolean
  updateSearchParams: (...args: Array<any>) => any
  scrollContainer: HTMLDivElement | null | undefined
}

class DateFilter extends Component<Props> {
  _handleAllTimeClick: () => any = () =>
    this.props.updateSearchParams({
      startDate: minDate,
      endDate: null,
    })
  _handleDateChange: (startDate: Date, endDate: Date) => any | void = (
    startDate: Date,
    endDate: Date,
  ) => {
    if (
      startDate.getTime() <= minDate.getTime() &&
      isSameDay(endDate, new Date())
    ) {
      return this._handleAllTimeClick()
    }

    this.props.updateSearchParams({
      startDate,
      endDate,
    })
  }

  render(): React.ReactNode {
    const { dateStart, dateEnd, scrollContainer } = this.props
    const mEnd = dateEnd || null
    const allTimeClass = cn('SearchResults_FilterOption', {
      SearchResults_FilterOption_Expandable_AlignTop: true,
      'is-active':
        (dateStart.getTime() === new Date(0).getTime() ||
          dateStart.getTime() < 0) &&
        (!mEnd || isSameDay(mEnd, new Date())),
    })
    return (
      <FilterRow caption="Filter by date:">
        <a onClick={this._handleAllTimeClick} className={allTimeClass}>
          Time
        </a>
        <DateRangePicker
          disabled={this.props.disabled}
          className="SearchResults_FilterOption SearchResults_FilterDate"
          minDate={minDate}
          maxDate={new Date()}
          theme="search"
          startDate={this.props.dateStart}
          endDate={this.props.dateEnd}
          onChange={this._handleDateChange}
          applyButton={false}
          showPredefinedRanges
          autoApply
          allTimeCaption="Select period"
          scrollContainer={scrollContainer}
        />
      </FilterRow>
    )
  }
}

export default DateFilter
